import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import {
  Button, ButtonToolbar, Modal, Table, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import Moment from 'moment';

import CreatableSelect from 'react-select/lib/Creatable';
import AsyncSelect from 'react-select/lib/Async';
import SelectService from '../../../services/SelectService';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class AddTransactionModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    locationID: PropTypes.string,
    modal: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
    locationType: PropTypes.string,
    postValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
  };

  static defaultProps = {
    title: 'User',
    color: 'primary',
    locationID: '',
    postValue: {},
    modal: false,
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
    errorMsg: '',
    locationType: 0,
  };

  constructor() {
    super();
    this.state = {
      modal: false,
      transactionType: '',
      accountsReceivable: 0,
      amountPaid: 0,
      prodIndexes: [{
        index: 0,
        quality: 0,
        unitCost: 0,
        total: 0,
      }],
      formdata: {
        chequeDate: new Date(),
        paymentType: '',
      },
      delivertoOptions: [],
    };

    this.isLoading = false;
    this.toggle = this.toggle.bind(this);
    this.onChangeQuantityAndCost = this.onChangeQuantityAndCost.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    this.getProducts('');
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.errorMsg && nextProps.modal) {
      this.setState({
        prodIndexes: [{
          index: 0,
          total: 0,
        }],
        grandTotal: 0,
        formdata: {
          chequeDate: new Date(),
          paymentType: '',
        },
      });

      const { transactionType } = this.state;
      if (transactionType === '4') {
        this.getDRnumber();
      }
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  getProducts = async (newValue) => {
    this.isLoading = true;
    const { locationID } = this.props;
    const formData = { searchFor: newValue, locationId: locationID };
    const options = [];
    if (this.isLoading) {
      await SelectService.listStoreProductsOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.ic_id,
              label: opt.product_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
      this.isLoading = false;
    }

    return options;
  }

  getBatch = async (id) => {
    this.isLoading = true;
    const formData = { controlid: id };
    const options = [];
    const { locationType } = this.props;

    if (this.isLoading) {
      if (locationType && locationType === '1') {
        await SelectService.listItemBatch(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.batch_value,
                label: opt.batch_text,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
      } else {
        await SelectService.listEntryBatch(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.batch_value,
                label: opt.batch_text,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
      }


      this.isLoading = false;
    }

    // this.setState({ batchoptions: options });
    return options;
  }

  getSuppliers = async (newValue) => {
    const formData = { searchFor: newValue };
    const options = [];
    this.isLoading = true;
    if (this.isLoading) {
      await SelectService.listSupplierOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.supplier_id,
              label: opt.supplier_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }

    return options;
  }

  getLocations = async (newValue) => {
    const { transactionType } = this.state;
    const { locationID, locationType } = this.props;
    let tType = transactionType;

    if (locationType && locationType === '0' && transactionType === 2) {
      tType = 3;
    }

    const formData = { searchFor: newValue, searchType: tType, locationid: locationID };
    const options = [];
    this.isLoading = true;

    try {
    if (this.isLoading) {
       await SelectService.listLocationOptions(formData).then((response) => {
          if (response) {
          response.map(opt => (
             options.push({
                value: opt.location_id,
                label: opt.location_name,
             })
          ));
          }
       }).catch((error) => {
          console.log('Error: ', error.message);
       });
       this.isLoading = false;
    }
    } catch (err) {
    console.log('Error: ', err.message);
    this.isLoading = false;
    }

    this.setState({ delivertoOptions: options });
 }

  getDRnumber = async () => {
    const { locationID } = this.props;
    const response = await CommonService.getRows(`transactiondr/locationid/${locationID}`);
    if (response) {
      document.getElementsByName('drNumber')[0].value = response;
    }
  }

  addProduct = (e) => {
    e.preventDefault();
    const { prodIndexes } = this.state;
    const lastItem = prodIndexes.slice(-1)[0].index;
    prodIndexes.push({
      index: parseInt(lastItem + 1, 10),
      total: 0,
    });
    this.setState({ ...prodIndexes, prodIndexes });
  }

  handleChange = (e, fieldName = '') => {
    if (fieldName === 'paymenttype') {
      let paymentType = '';
      if (e) {
        paymentType = e.target.value;
      }
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, paymentType },
      }));
    } else if (fieldName === 'idate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, inventoryDate: Moment(date).format('YYYY-MM-DD HH:mm:ss') },
      }));
    } else if (fieldName === 'cdate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, chequeDate: Moment(date).format('YYYY-MM-DD HH:mm:ss') },
      }));
    } else if (fieldName === 'ddate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, deliveryDate: Moment(date).format('YYYY-MM-DD HH:mm:ss') },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
 }

  handleSelectChange = (e) => {
    const t = e.target.value;
    this.setState({ transactionType: t });

    setTimeout(() => {
      this.getLocations('');

      if (t === '4') {
        this.getDRnumber();
      }
    }, 100);
  }

  handleInputChange = (e) => {
    const { delivertoOptions } = this.state;
    const testD = delivertoOptions.filter(item => item.label === e);

    this.getLocations(e);
    if (testD.length <= 0) {
      this.setState({ deliverToVal: e });
    } else {
      this.setState({ deliverToVal: '' });
    }
  }

  handleBatchChange = async (e, index = '') => {
    const { locationID } = this.props;

    if (e.target.value) {
      const response = await CommonService.getRows(`controlbatchdata/locationid/${locationID}/controlid/${e.target.value}`);
      if (response && index !== '') {
        document.getElementById(`entrystock${index}`).innerHTML = response.quantity;
      }
    }
  }

  handleProductChange = async (e, index = '') => {
    const { prodIndexes, transactionType } = this.state;

    if (index !== '') {
      const objIdx = prodIndexes.findIndex(x => x.index === index);
      const batch = document.getElementsByName(`batch[${index}]`)[0];
      document.getElementById(`entrystock${index}`).innerHTML = 0;

      if (transactionType === '4') {
        document.getElementsByName(`unitCost[${index}]`)[0].value = '';
      }

      const batchlist = await this.getBatch(e.value);
      if (batchlist) {
        batch.options.length = 0;
        const dOptions = document.createElement('option');
          dOptions.text = '-- Select --';
          dOptions.value = '';
          batch.appendChild(dOptions);

        batchlist.map((b) => {
          const option = document.createElement('option');
          option.text = b.label;
          option.value = b.value;
          return (batch.appendChild(option));
        });
      }

      prodIndexes[objIdx].batch = batchlist;
      this.setState({ prodIndexes });
    }
  }

  onChangeQuantityAndCost = (e, index = '') => {
    const {
      prodIndexes, amountPaid, transactionType,
    } = this.state;
    const ret = global.numbersonly(e);
    let quantity = 0;
    let unitcost = 0;
    let total = 0;
    let gTotal = 0;

    // replace non-numeric values to empty
    if (!ret) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
    }

    // calculate total
    if (index !== '') {
      const docQ = document.getElementsByName(`quantity[${index}]`)[0].value;
      quantity = docQ !== '' ? docQ : 0;
      quantity = parseFloat(quantity, 10);
      const objIdx = prodIndexes.findIndex(x => x.index === index);

      if (transactionType === '4') {
        const docUc = document.getElementsByName(`unitCost[${index}]`)[0].value;
        unitcost = docUc !== '' ? docUc : 0;
        unitcost = parseFloat(unitcost, 10);
        total = parseFloat(quantity * unitcost, 10).toFixed(2);
        prodIndexes[objIdx].total = total;
      }

      if (prodIndexes) {
        prodIndexes.map((item) => {
          gTotal = parseFloat(gTotal, 10) + parseFloat(item.total, 10);
          return gTotal.toFixed(2);
        });
      }

      let amPaid = amountPaid;
      if (amPaid > gTotal) {
        amPaid = gTotal;
      }
    }

    this.setState({
      accountsReceivable: 0, prodIndexes, grandTotal: gTotal, amountPaid: gTotal,
    });
  }

  onChangeBalance = (e) => {
    const { accountsReceivable, grandTotal } = this.state;
    const ret = global.numbersonly(e);
    const total = grandTotal ? parseFloat(grandTotal, 10) : 0;
    let amountpaid = parseFloat(e.target.value, 10);
    let balance = accountsReceivable;

    // replace non-numeric values to empty
    if (!ret) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
    }

    // update balance and amount paid
    if (amountpaid > total) {
      balance = 0;
      amountpaid = total;
    } else {
      balance = parseFloat(total, 10) - amountpaid;
    }

    amountpaid = !Number.isNaN(amountpaid) ? amountpaid : 0;
    balance = !Number.isNaN(balance) ? balance.toFixed(2) : 0;

    this.setState({ accountsReceivable: balance, amountPaid: amountpaid });
  }

  removeProdItem = (e, index) => {
    e.preventDefault();
    let { prodIndexes } = this.state;
    prodIndexes = prodIndexes.filter(resp => parseInt(resp.index, 10) !== parseInt(index, 10));
    this.setState({ prodIndexes });
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      color, modal, toggle, title, handleChange, handleSubmit, errorMsg, postValue, locationType,
    } = this.props;
    const {
      prodIndexes, grandTotal, transactionType, delivertoOptions, deliverToVal, formdata, amountPaid, accountsReceivable,
    } = this.state;
    const selectediDate = new Date(postValue.inventoryDate);

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header modal-vx"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title}</h4>
          </div>
          <form id="insertTransaction_form" onSubmit={handleSubmit}>
            <div className="modal__body">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <div className="alert__content">
                      <div>{ parse(errorMsg) }</div>
                    </div>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Inventory Date: <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <div className="date-picker">
                      <DatePicker
                        name="inventoryDate"
                        selected={selectediDate}
                        onChange={e => handleChange(e, 'idate')}
                      />
                    </div>
                    <div className="form__form-group-icon">
                      <i className="fa fa-calendar-alt" />
                    </div>
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">DR #: <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="drNumber" placeholder="Deliver Receipt No." onChange={handleChange} />
                  </div>
                </div>
                <div className="form__form-group">
                    <span className="form__form-group-label">Category: <b className="text-danger">*</b></span>
                    <div className="form__form-group-field">
                    <select onChange={this.handleSelectChange} value={transactionType} name="transactionType">
                        <option value="">-- Select Category -</option>
                        {/* <option value="1">Warehouse</option>
                        <option value="2">Logistic</option> */}
                        {
                          locationType && locationType === '1' && (
                            <>
                            <option value="2">Logistic</option>
                            </>
                          )
                        }
                        <option value="3">Store</option>
                        <option value="4">Direct Customer</option>
                    </select>
                    </div>
                </div>

                <div className="form__form-group">
                    <span className="form__form-group-label">Deliver To: <b className="text-danger">*</b></span>
                    <div className="form__form-group-field">
                    <CreatableSelect
                        name="deliverTo"
                        options={delivertoOptions}
                        isClearable
                        onChange={e => handleChange(e, 'deliver')}
                        onInputChange={this.handleInputChange}
                        className="react-select"
                        classNamePrefix="react-select"
                        placeholder="Delivery destination..."
                        isValidNewOption={transactionType === '4' && deliverToVal !== '' ? () => true : () => false}
                    />
                    </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Delivery Date: <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <div className="date-picker">
                      <DatePicker
                        name="deliveryDate"
                        selected={formdata.deliveryDate ? new Date(formdata.deliveryDate) : new Date()}
                        onChange={e => this.handleChange(e, 'ddate')}
                      />
                    </div>
                    <div className="form__form-group-icon">
                      <i className="fa fa-calendar-alt" />
                    </div>
                  </div>
                </div>

                {
                  transactionType && transactionType === '4' && (
                  <div className="form__form-group">
                    <span className="form__form-group-label">Payment Type <b className="text-danger">*</b></span>
                    <div className="form__form-group-field">
                      <select name="paymentType" onChange={e => this.handleChange(e, 'paymenttype')}>
                        <option value="">-- Select --</option>
                        {
                          Object.keys(global.paymentType).map(k => (
                          <option key={k} value={k}>{global.paymentType[k]}</option>
                          ))
                        }
                      </select>
                    </div>
                  </div>
                  )
                }

                {
                  (formdata.paymentType && formdata.paymentType === '1') && (transactionType && transactionType === '4') && (
                    <>
                    <div className="form__form-group">
                        <strong className="text-primary"><u>Cheque Details</u></strong>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Bank <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="bank" placeholder="Bank" />
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Cheque No. <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="chequeNum" placeholder="Cheque No." />
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Cheque Date <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <div className="date-picker">
                            <DatePicker
                              name="chequeDate"
                              selected={formdata.chequeDate ? new Date(formdata.chequeDate) : new Date()}
                              onChange={e => this.handleChange(e, 'cdate')}
                            />
                          </div>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Account No. <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="accountNum" placeholder="Account No." />
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Account Name <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="accountName" placeholder="Account Name" />
                        </div>
                    </div>
                    </>
                  )
                }

                <Table className="no_hover transaction_board" id="product_table">
                  <thead>
                    <tr>
                      <th width="180px">Product <b className="text-danger">*</b></th>
                      <th width="180px">Batch <b className="text-danger">*</b></th>
                      <th>Stock</th>
                      <th>Quantity <span className="text-danger"><i>(Kilos)</i> *</span></th>
                      {
                        transactionType && transactionType === '4' && (
                          <>
                          <th>Unit Cost <b className="text-danger">*</b></th>
                          <th>Total <b className="text-danger">*</b></th>
                          </>
                        )
                      }
                      <th><></></th>
                    </tr>
                  </thead>
                  <tbody>
                    {prodIndexes.length > 0 && prodIndexes.map((item) => {
                      const trkey = `tr_row${item.index}`;

                      return (
                        <tr key={trkey}>
                          <td data-tx="Product" className="v-top">
                            <AsyncSelect
                              name={`product[${item.index}]`}
                              cacheOptions
                              loadOptions={this.getProducts}
                              defaultOptions
                              className="react-select"
                              classNamePrefix="react-select"
                              placeholder="Select Product"
                              onChange={e => this.handleProductChange(e, item.index)}
                            />
                          </td>
                          <td data-tx="Batch" className="v-top">
                            <select name={`batch[${item.index}]`} onChange={e => this.handleBatchChange(e, item.index)}>
                              <option value="">-- Select --</option>
                            </select>
                          </td>
                          <td className="td_total" id={`entrystock${item.index}`} data-tx="Stock"> {item.total ? `${parseFloat(item.total, 10).toFixed(2)}kgs` : 0 }</td>
                          <td data-tx="Quantity">
                            <input type="text" name={`quantity[${item.index}]`} placeholder="Quantity" onChange={e => this.onChangeQuantityAndCost(e, item.index)} />
                          </td>
                          {
                            transactionType && transactionType === '4' && (
                              <>
                                <td data-tx="Unit Cost">
                                  <input type="text" name={`unitCost[${item.index}]`} placeholder="Unit Cost" onChange={e => this.onChangeQuantityAndCost(e, item.index)} />
                                </td>
                                <td className="td_total" data-tx="Total"><span className="m-r-3">&#x20B1;</span> {item.total ? parseFloat(item.total, 10).toFixed(2) : 0 }</td>
                              </>
                            )
                          }

                          <td className="le-td text-center">
                            {
                              item.index !== 0 && (
                                <Button type="button" className="rounded btn-xs le-btn" onClick={e => this.removeProdItem(e, item.index)}><i className="fa fa-times" /> <span>Remove Product</span></Button>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <div id="add_product_btn" className="text-right col-md-12 p-0">
                  <Button onClick={this.addProduct} color="success" className="rounded m-b-10" size="sm"><i className="fa fa-plus-circle" />&nbsp; Add Product</Button>
                </div>

                <div className="full-width">
                  <Table className="no_hover">
                    <tbody>
                        {
                          transactionType && transactionType === '4' && (
                            <>
                            <tr>
                              <td className="bold">Grand Total:</td>
                              <td className="text-right text-danger" width="40px">&#x20B1;</td>
                              <td className="text-primary n" width="160px">
                                {grandTotal}
                              </td>
                            </tr>
                            <tr>
                              <td className="bold">Amount Paid</td>
                              <td className="text-right" width="40px">&#x20B1;</td>
                              <td className="n" width="160px">
                                <input type="text" name="amountPaid" placeholder="Amount Paid" value={amountPaid >= 0 ? amountPaid.toString() : ''} onChange={this.onChangeBalance} />
                              </td>
                            </tr>
                            <tr>
                              <td className="bold">Balance</td>
                              <td className="text-right text-danger" width="40px">&#x20B1;</td>
                              <td className="bold text-danger n" width="160px">{accountsReceivable ? accountsReceivable.toString() : 0}</td>
                            </tr>
                            </>
                          )
                        }
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color={color}>Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'warehouse_insertInventory', // a unique identifier for this form
})(withTranslation('common')(AddTransactionModal));
